import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const COMPANY_PATH = "/company/v1";

export const getCompanyApi = async (params, options = {}) => await getRequest(COMPANY_PATH, params, options);

export const getCompanyByIdApi = async (id) =>
  await getRequest(`${COMPANY_PATH}/${id}`);

export const addCompanyApi = async (data) =>
  await postRequest(COMPANY_PATH, data);

export const updateCompanyApi = async (id, data) =>
  await putRequest(`${COMPANY_PATH}/${id}`, data);

export const deleteCompanyByIdApi = async (id) =>
  await deleteRequest(`${COMPANY_PATH}/${id}`);
